'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var index$1 = require('../../../atoms/IconSvg/index.js');
var classnames = require('classnames');
var index = require('../store/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var WizardProgressItem = function WizardProgressItem(_ref) {
  var index$2 = _ref.index,
      title = _ref.title;

  var _useContext = React.useContext(index.default),
      checkedSteps = _useContext.checkedSteps,
      currentStep = _useContext.currentStep,
      onNavigateToStep = _useContext.onNavigateToStep;

  var isChecked = checkedSteps.has(index$2);
  var isCurrent = currentStep === index$2;

  var onClickButton = function onClickButton() {
    onNavigateToStep(index$2);
  };

  var renderSignalContent = function renderSignalContent() {
    if (!isCurrent) {
      return isChecked ? /*#__PURE__*/React__default['default'].createElement(index$1, {
        icon: "tick"
      }) : index$2 + 1;
    }

    return null;
  };

  return /*#__PURE__*/React__default['default'].createElement("button", {
    className: classnames__default['default']('ds-organisms-wizard-progress-item', {
      current: isCurrent,
      checked: !isCurrent && isChecked
    }),
    onClick: onClickButton,
    type: "button"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-progress-item-signal"
  }, renderSignalContent()), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-progress-item-title"
  }, title));
};

WizardProgressItem.propTypes = {
  index: PropTypes__default['default'].number.isRequired,
  title: PropTypes__default['default'].string.isRequired
};
var WizardProgressItem$1 = React.memo(WizardProgressItem);

module.exports = WizardProgressItem$1;
